/* AE Reviews wall (sections/ae-reviews-wall.liquid).
   Reads the product's reviews from the review app's public feed and prints them in the redesign's layout.
   The "Verified buyer" tick comes only from the app's own flag on each review (data-verified-buyer="true"). */
(function () {
  'use strict';
  var FEED = 'https://api.judge.me/reviews/reviews_for_widget';
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.5l2.5 5.4 5.9.7-4.4 4 1.2 5.8L10 14.5l-5.2 2.9L6 11.6l-4.4-4 5.9-.7z"/></svg>';
  var TICK = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M4.5 8.3l2.3 2.3 4.7-5" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CROSS = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function stars(n, size) {
    var five = STAR + STAR + STAR + STAR + STAR;
    var pct = Math.max(0, Math.min(100, n / 5 * 100));
    return '<span class="ae-rw__stars" role="img" aria-label="' + (Math.round(n * 10) / 10) + ' out of 5 stars"' + (size ? ' style="--rw-sz:' + size + 'px"' : '') + '>' +
      five + '<span class="ae-rw__starson" style="width:' + pct + '%">' + five + '</span></span>';
  }
  function text(el, sel) {
    var n = el.querySelector(sel);
    return n ? n.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function paras(el, sel) {
    var n = el.querySelector(sel);
    if (!n) return '';
    var ps = n.querySelectorAll('p');
    var out = [];
    if (ps.length) {
      for (var i = 0; i < ps.length; i++) out.push(ps[i].textContent.replace(/[ \t]+/g, ' ').trim());
    } else {
      out.push(n.textContent.replace(/[ \t]+/g, ' ').trim());
    }
    return out.filter(Boolean).join('\n\n');
  }
  function when(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    return d.getUTCDate() + ' ' + MON[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
  }
  function safeUrl(u) {
    return /^https:\/\//i.test(u || '') ? u : '';
  }

  /* one review element from the feed -> plain object */
  function read(el) {
    var rating = el.querySelector('.jdgm-rev__rating');
    var time = el.querySelector('.jdgm-rev__timestamp');
    var pics = [];
    var links = el.querySelectorAll('.jdgm-rev__pic-link');
    for (var i = 0; i < links.length; i++) {
      var img = links[i].querySelector('img');
      var src = safeUrl(img && (img.getAttribute('data-src') || img.getAttribute('src')));
      var href = safeUrl(links[i].getAttribute('href')) || src;
      if (src) pics.push({ src: src, href: href });
    }
    var iso = time ? (time.getAttribute('datetime') || time.getAttribute('data-content') || '') : '';
    return {
      verified: el.getAttribute('data-verified-buyer') === 'true',
      helpful: parseInt(el.getAttribute('data-thumb-up-count'), 10) || 0,
      name: text(el, '.jdgm-rev__author') || 'Customer',
      stars: rating ? (parseInt(rating.getAttribute('data-score'), 10) || 0) : 0,
      iso: iso,
      ts: Date.parse(iso) || 0,
      title: text(el, '.jdgm-rev__title'),
      body: paras(el, '.jdgm-rev__body'),
      reply: paras(el, '.jdgm-rev__reply-content'),
      pics: pics,
      tags: []
    };
  }

  function load(shop, pid) {
    var all = [];
    /* the feed gives 30 reviews a page at most, so larger products are read page by page */
    function page(n) {
      var url = FEED + '?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&per_page=30&page=' + n + '&product_id=' + encodeURIComponent(pid);
      return fetch(url, { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('feed ' + r.status);
        return r.json();
      }).then(function (d) {
        var doc = new DOMParser().parseFromString(d.html || '', 'text/html');
        var els = doc.querySelectorAll('.jdgm-rev');
        for (var i = 0; i < els.length; i++) all.push(read(els[i]));
        var total = parseInt(d.total_count, 10) || all.length;
        if (els.length && all.length < total && n < 10) return page(n + 1);
        return all;
      });
    }
    return page(1);
  }

  /* "Label | word, word*" rules -> testers */
  function rules(list) {
    return (list || []).map(function (t) {
      var parts = String(t.words || '').split(',').map(function (w) { return w.trim().toLowerCase(); }).filter(Boolean).map(function (w) {
        var open = w.slice(-1) === '*';
        if (open) w = w.slice(0, -1);
        return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+') + (open ? '[a-z]*' : '');
      });
      if (!parts.length) return null;
      return { label: t.label, re: new RegExp('(^|[^a-z0-9])(' + parts.join('|') + ')(?=$|[^a-z0-9])', 'i') };
    }).filter(Boolean);
  }

  function init(root) {
    if (root.__aeRw) return;
    root.__aeRw = true;
    var cfg = { labels: {}, topics: [] };
    try { cfg = JSON.parse(root.querySelector('[data-ae-rw-cfg]').textContent); } catch (e) {}
    var L = cfg.labels || {};
    var per = parseInt(root.getAttribute('data-per'), 10) || 5;
    var sum = root.querySelector('[data-ae-rw-sum]');
    var tool = root.querySelector('[data-ae-rw-tool]');
    var list = root.querySelector('[data-ae-rw-list]');
    var end = root.querySelector('[data-ae-rw-end]');
    var endn = root.querySelector('[data-ae-rw-endn]');
    var more = root.querySelector('[data-ae-rw-more]');
    var write = root.querySelectorAll('[data-ae-rw-write]');
    /* the Verified buyer tick, switch and note are a setting; off hides them even when the app has verified reviews */
    var showVerified = cfg.verifiedOn === true;
    var state = { sort: 'recent', star: 0, topic: '', vonly: false, shown: per };
    var all = [], topics = [], anyVerified = false, anyHelpful = false;

    /* Write a review: use the review app's own form when its widget is on the page, else the link from the settings.
       The app opens its form inside its own widget, so once this section shows the reviews the widget is moved
       into the slot under the section (only its form shows there) and the form opens in that slot. */
    var slot = root.parentNode.querySelector('[data-ae-rw-form]');
    function appWidget() { return document.querySelector('.jdgm-review-widget'); }
    function wireWrite() {
      var url = root.getAttribute('data-write-url');
      var has = !!appWidget();
      for (var i = 0; i < write.length; i++) {
        if (has) { write[i].hidden = false; }
        else if (url) { write[i].setAttribute('href', url); write[i].hidden = false; }
      }
    }
    function adopt() {
      var widget = appWidget();
      if (!widget || !slot || slot.contains(widget) || (window.Shopify && Shopify.designMode)) return;
      var box = widget.closest('.shopify-section');
      slot.appendChild(widget);
      if (box && !box.contains(root) && box.querySelectorAll('.shopify-app-block').length <= 1) box.classList.add('ae-rw-app-off');
    }
    function openForm() {
      var widget = appWidget();
      var link = widget && widget.querySelector('.jdgm-write-rev-link');
      if (!link) return false;
      var tries = 0;
      (function go() {
        var form = widget.querySelector('.jdgm-form-wrapper');
        if (form && form.offsetHeight > 0) {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        link.click();
        if (++tries < 8) setTimeout(go, 900);
      })();
      return true;
    }
    root.addEventListener('click', function (e) {
      var w = e.target.closest('[data-ae-rw-write]');
      if (w && openForm()) e.preventDefault();
    });

    function view() {
      var out = all.filter(function (r) {
        if (state.star && r.stars !== state.star) return false;
        if (state.vonly && !r.verified) return false;
        if (state.topic && r.tags.indexOf(state.topic) < 0) return false;
        return true;
      });
      var by = {
        recent: function (a, b) { return b.ts - a.ts; },
        helpful: function (a, b) { return b.helpful - a.helpful || b.ts - a.ts; },
        high: function (a, b) { return b.stars - a.stars || b.ts - a.ts; },
        low: function (a, b) { return a.stars - b.stars || b.ts - a.ts; }
      }[state.sort];
      return out.sort(by);
    }

    function card(r) {
      var h = '<article class="ae-rw__card ae-rw__rv"><header class="ae-rw__rvh">' +
        '<span class="ae-rw__av" aria-hidden="true">' + esc(r.name.charAt(0).toUpperCase()) + '</span>' +
        '<span class="ae-rw__who"><span class="ae-rw__name"><strong>' + esc(r.name) + '</strong>' +
        (r.verified && showVerified ? '<span class="ae-rw__vb">' + TICK + esc(L.verified || 'Verified buyer') + '</span>' : '') + '</span>' +
        '<span class="ae-rw__meta">' + (r.desc ? '<span class="ae-rw__desc">' + esc(r.desc) + '</span>' : '') +
        (r.iso ? '<time datetime="' + esc(r.iso) + '">' + when(r.iso) + '</time>' : '') + '</span></span>' +
        stars(r.stars) + '</header>';
      if (r.title) h += '<p class="ae-rw__title">' + esc(r.title) + '</p>';
      if (r.body) h += '<p class="ae-rw__body is-clamp">' + esc(r.body) + '</p>';
      if (r.pics.length) {
        h += '<span class="ae-rw__pics">' + r.pics.map(function (p) {
          return '<a href="' + esc(p.href) + '" target="_blank" rel="noopener"><img src="' + esc(p.src) + '" alt="Customer photo" loading="lazy" width="72" height="72"></a>';
        }).join('') + '</span>';
      }
      if (r.reply) h += '<p class="ae-rw__reply"><strong>' + esc(root.getAttribute('data-reply') || 'Reply') + '</strong>' + esc(r.reply) + '</p>';
      if (r.tags.length) h += '<span class="ae-rw__tags">' + r.tags.map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('') + '</span>';
      return h + '</article>';
    }

    function paintSummary() {
      var n = all.length, total = 0, hist = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
      all.forEach(function (r) { total += r.stars; if (hist[r.stars] != null) hist[r.stars]++; });
      var avg = n ? total / n : 0;
      /* shown to one decimal, cut not rounded: 4.96 reads 4.9, so the score never says 5.0 unless every review is 5 stars */
      var shown = (Math.floor(avg * 10 + 1e-9) / 10).toFixed(1);
      var based = String(L.based || 'Based on {count} reviews').split('{count}');
      var h = '<span class="ae-rw__score"><span class="ae-rw__scoren">' + shown + '</span><span class="ae-rw__scoret">' + stars(avg, 19) +
        '<span>' + esc(based[0]) + (based.length > 1 ? '<b>' + n + '</b>' + esc(based[1]) : '') + '</span></span></span>';
      h += '<span class="ae-rw__hist">' + [5, 4, 3, 2, 1].map(function (k) {
        return '<button type="button" class="ae-rw__hrow" data-star="' + k + '" aria-pressed="' + (state.star === k) + '"' + (hist[k] ? '' : ' disabled') +
          ' aria-label="' + k + ' star reviews: ' + hist[k] + '"><span class="ae-rw__hlab">' + k + STAR + '</span><span class="ae-rw__hbar"><i style="width:' + (n ? Math.round(hist[k] / n * 100) : 0) + '%"></i></span><span class="ae-rw__hn">' + hist[k] + '</span></button>';
      }).join('') + '</span>';
      if (topics.length) {
        h += '<span class="ae-rw__sep"></span><span class="ae-rw__topics"><span class="ae-rw__lab">' + esc(L.mentioned || 'Mentioned in reviews') + '</span><span class="ae-rw__ment">' + topics.map(function (t) {
          return '<button type="button" class="ae-rw__chip" data-topic="' + esc(t.label) + '" aria-pressed="' + (state.topic === t.label) + '">' + esc(t.label) + '<b>' + t.n + '</b></button>';
        }).join('') + '</span></span>';
      }
      if (anyVerified) {
        h += '<span class="ae-rw__sep"></span><span class="ae-rw__vnote">' + TICK + '<span><b>' + esc(L.verified || 'Verified buyer') + '</b> ' + esc(L.verifiedNote || '') + '</span></span>';
      }
      sum.innerHTML = h;
    }

    function paintList() {
      var rows = view(), n = Math.min(state.shown, rows.length);
      var filter = state.star ? state.star + ' star' : (state.topic || '');
      tool.innerHTML = '<span class="ae-rw__tooll"><span>Showing <b>' + n + '</b> of ' + rows.length + ' review' + (rows.length === 1 ? '' : 's') + '</span>' +
        (filter ? '<button type="button" class="ae-rw__clear" data-clear>' + esc(filter) + CROSS + '</button>' : '') + '</span>' +
        '<span class="ae-rw__toolr">' +
        (anyVerified ? '<button type="button" class="ae-rw__sw" role="switch" aria-checked="' + state.vonly + '" data-vonly><i></i>' + esc(L.verifiedOnly || 'Verified buyers only') + '</button>' : '') +
        '<label class="ae-rw__sort"><span>Sort by</span><select data-sort aria-label="Sort reviews">' +
        [['recent', 'Most recent'], ['helpful', 'Most helpful'], ['high', 'Highest rated'], ['low', 'Lowest rated']].filter(function (o) { return o[0] !== 'helpful' || anyHelpful; }).map(function (o) {
          return '<option value="' + o[0] + '"' + (state.sort === o[0] ? ' selected' : '') + '>' + o[1] + '</option>';
        }).join('') + '</select></label></span>';
      list.innerHTML = rows.slice(0, n).map(card).join('') || '<p class="ae-rw__card ae-rw__rv ae-rw__empty">' + esc(L.empty || 'No reviews yet.') + '</p>';
      /* Read more only where the text is really cut */
      var bodies = list.querySelectorAll('.ae-rw__body');
      for (var i = 0; i < bodies.length; i++) {
        if (bodies[i].scrollHeight > bodies[i].clientHeight + 2) {
          bodies[i].insertAdjacentHTML('afterend', '<button type="button" class="ae-rw__more" data-more aria-expanded="false">Read more</button>');
        } else {
          bodies[i].classList.remove('is-clamp');
        }
      }
      end.hidden = rows.length <= n;
      if (endn) endn.textContent = n + ' of ' + rows.length + ' shown';
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-star')) {
        var k = parseInt(t.getAttribute('data-star'), 10);
        state.star = state.star === k ? 0 : k; state.topic = ''; state.shown = per; paintSummary(); paintList();
      } else if (t.hasAttribute('data-topic')) {
        var lab = t.getAttribute('data-topic');
        state.topic = state.topic === lab ? '' : lab; state.star = 0; state.shown = per; paintSummary(); paintList();
      } else if (t.hasAttribute('data-clear')) {
        state.star = 0; state.topic = ''; state.shown = per; paintSummary(); paintList();
      } else if (t.hasAttribute('data-vonly')) {
        state.vonly = !state.vonly; state.shown = per; paintList();
      } else if (t.hasAttribute('data-ae-rw-more')) {
        state.shown += per; paintList();
      } else if (t.hasAttribute('data-more')) {
        var body = t.previousElementSibling;
        var open = body.classList.toggle('is-clamp') === false;
        t.textContent = open ? 'Show less' : 'Read more';
        t.setAttribute('aria-expanded', open);
      }
    });
    root.addEventListener('change', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-sort')) { state.sort = e.target.value; state.shown = per; paintList(); }
    });

    wireWrite();
    load(root.getAttribute('data-shop'), root.getAttribute('data-product')).then(function (rows) {
      all = rows;
      var rs = rules(cfg.topics), count = {};
      /* reviewer descriptions typed in the section settings ("Name | Description"), matched on the name as shown */
      var descs = {};
      (cfg.descs || []).forEach(function (d) { if (d.name && d.text) descs[String(d.name).toLowerCase().replace(/\s+/g, ' ').trim()] = d.text; });
      all.forEach(function (r) {
        r.desc = descs[r.name.toLowerCase()] || '';
        var hay = r.title + ' ' + r.body;
        rs.forEach(function (x) { if (x.re.test(hay)) { count[x.label] = (count[x.label] || 0) + 1; if (r.tags.length < 4) r.tags.push(x.label); } });
        if (r.verified && showVerified) anyVerified = true;
        if (r.helpful) anyHelpful = true;
      });
      topics = Object.keys(count).map(function (k) { return { label: k, n: count[k] }; }).filter(function (t) { return t.n > 1; })
        .sort(function (a, b) { return b.n - a.n; }).slice(0, 6);
      root.classList.remove('is-loading');
      if (!all.length) {
        sum.innerHTML = '<span class="ae-rw__empty">' + esc(L.empty || 'No reviews yet.') + '</span>';
        list.innerHTML = '';
        root.querySelector('.ae-rw__main').hidden = true;
        wireWrite();
        return;
      }
      paintSummary();
      tool.hidden = false;
      paintList();
      /* this section now shows the reviews: the review app's own widget moves to the form slot */
      adopt();
      wireWrite();
    }).catch(function () {
      /* feed not reachable: step aside and leave the review app's own widget to do the job */
      root.hidden = true;
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ae-rw]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
